import { Caption, parseSrt } from '@remotion/captions';

const getSubtitlesFromSrt = async (src: string) => {
  const res = await fetch(src);
  const text = await res.text();

  const { captions } = parseSrt({
    input: text,
  });

  return captions.map((c) => {
    return {
      ...c,
      text: ` ${c.text}`,
    };
  });
};

const getSubtitlesFromJson = async (src: string) => {
  const res = await fetch(src);
  const captions = (await res.json()) as Caption[];

  return captions;
};

const getSubtitlesFromMediaInboxFormat = async (src: string) => {
  const res = await fetch(src);
  const captions = convertMediainboxFormatToStandardCaptions(await res.json()) as Caption[];

  return captions;
};

export const convertMediainboxFormatToStandardCaptions = (
  fragmentCaptions: Array<{
    start: number;
    end: number;
    word: string;
    confidence: number;
  }>,
) => {
  return fragmentCaptions.map((caption) => ({
    text: caption.word,
    startMs: caption.start * 1000,
    endMs: caption.end * 1000,
    timestampMs: ((caption.start + caption.end) / 2) * 1000,
    confidence: caption.confidence,
  }));
};

export const getSubtitles = (src: string) => {
  if (src.endsWith('.mi.json')) {
    return getSubtitlesFromMediaInboxFormat(src);
  }

  if (src.endsWith('.json')) {
    return getSubtitlesFromJson(src);
  }

  if (src.endsWith('.srt')) {
    return getSubtitlesFromSrt(src);
  }

  return getSubtitlesFromMediaInboxFormat(src);
};
